module.exports = __webpack_public_path__ + "img/a3.e56fc621.png";